import { Container, Token } from 'typedi';
import { IAutologinAuthenticationService } from '../models/';
import { Lock } from '../../utils/lockUtil';

const moduleLock = new Lock();

export const AutoLoginAuthenticationServiceToken = new Token<IAutologinAuthenticationService>(
    'AutoLoginAuthenticationService',
);

export async function loadAutoLoginAuthenticationService(): Promise<IAutologinAuthenticationService> {
    await moduleLock.acquireLock();
    try {
        if (Container.has(AutoLoginAuthenticationServiceToken)) {
            return Container.get(AutoLoginAuthenticationServiceToken);
        }

        const module = await import(
            /* webpackChunkName: "authentication/service/autologin" */
            './autologin-authentication.service'
        );
        const newMyModuleInstance = new module.AutoLoginAuthenticationService();
        Container.set(AutoLoginAuthenticationServiceToken, newMyModuleInstance);
        moduleLock.releaseLock();
        return newMyModuleInstance;
    } finally {
        moduleLock.releaseLock();
    }
}
